import styled from 'styled-components'

import media from '../../../utils/media'

export const IllustrationWrapper = styled.div`
  display: block;
  margin: auto 0;
  height: auto;
  z-index: ${(props) => props.zindex};

  ${({ marginTop }) =>
    marginTop &&
    `
    margin-top:${marginTop}px;
  `};

  ${media.lessThan('md')`
      margin-top: 0px;
    `}

  ${({ marginBottom }) =>
    marginBottom &&
    `
    margin-bottom:${marginBottom}px;
  `};

  ${({ absolute }) =>
    absolute &&
    `
    position:${absolute};
  `};

  ${({ posiTop }) =>
    posiTop &&
    `
    top:${posiTop}%;
  `};

  ${({ posiBottom }) =>
    posiBottom &&
    `
    bottom:${posiBottom}%;
  `};

  ${({ posiLeft }) =>
    posiLeft &&
    `
    left:${posiLeft}%;
  `};

  ${({ posiRight }) =>
    posiRight &&
    `
    right:${posiRight}%;
  `};
`
